import Loader from './loader.component';
export default Loader;
